
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'
import { getDoctorAddresses, getDoctorInfo } from '../doctors/doctors.service'
import {
  Address,
  PNInformationResolve,
  RMTProgressNoteDrafts,
  Role
} from '@/models'
import { GetCPT } from '../admin/forms.service'
import { Debounce } from 'typescript-debounce'
import { getCurrentUser } from '../admin/users/users.service'
@Component
export default class PNInformation extends Vue {
  @Prop() public record!: string
  @Prop({ default: () => ({}) }) readonly data!: Record<string, any>

  @Prop({ default: () => ({}) }) readonly draft!: Record<string, any>

  localFormData: Record<string, any> = {}

  public PNInformationResolve = {} as PNInformationResolve
  public Draft = {} as RMTProgressNoteDrafts
  public selected = ''
  public selectedCPT = null
  public formatted = null
  public cptOptions = null
  public showOtherCPT = false
  public otherCPT = null
  public dataAvailable = false
  public options = [
    { text: 'Male', value: 'M' },
    { text: 'Female', value: 'F' }
  ]
  public form = {
    age: '',
    serviceDate: '',
    gender: ''
  }
  public addresses: Address[] = []
  dateFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }
  visibleAddressCount = 3
  minDate: string = this.computeMinDate()
  maxDate: Date = new Date()
  showMoreLessText = 'More'
  selectedAddress = {} as Address
  public onAddressSelect(address: Address, idx: number) {
    this.addresses.map(c => (c.selected = false))

    this.selectedAddress = address
    // this.addresses[idx].selected = true
    // this.$nextTick(() => {
    //   address.selected = true
    // })
    // console.log(this.addresses[idx])
  }

  get visibleAddresses() {
    return this.addresses.slice(0, this.visibleAddressCount)
  }
  public showMore() {
    this.showMoreLessText = 'More'

    console.log(this.visibleAddressCount)
    if (this.visibleAddressCount == this.addresses.length) {
      this.showLess()
    } else {
      this.visibleAddressCount = this.addresses.length
      this.showMoreLessText = 'Less'
    }
  }
  public showLess() {
    this.visibleAddressCount = 3
    this.addresses.slice(0, this.visibleAddressCount)
  }
  public async mounted() {
    this.cptOptions = await GetCPT()
    const currentUser = JSON.parse(localStorage.getItem('currentUser'))
    console.log(currentUser)
    const userId = currentUser.rmtUserId.toString()

    // if (currentUser.role == Role.DoctorStaff) {
    //   userId = currentUser.doctorHeadId.toString()
    // }

    // console.log(userId)
    // const userId = currentUser.role == "Doctor" ? getCurrentUser()
    this.addresses = await getDoctorAddresses(userId)

    this.selectedAddress = this.addresses[0]
    // this.addresses.map(c => c.selected == false)
    // console.log(this.addresses)
    // this.localFormData = { ...this.draft }
    // console.log(this.data)

    // console.log(this.data)
  }
  @Watch('selectedAddress', { immediate: true, deep: true })
  onSelectedAddress(address: Address) {
    // address.selected = true
    this.PNInformationResolve.doctorInfo.city = address.city
    this.PNInformationResolve.doctorInfo.email1 = address.email1
    this.PNInformationResolve.doctorInfo.phone = address.phone

    this.PNInformationResolve.doctorInfo = {
      ...this.PNInformationResolve.doctorInfo,
      ...address
    }

    console.log(this.PNInformationResolve.doctorInfo)
  }

  @Watch('selectedCPT', { immediate: true })
  onSelectedChange(newVal: number) {
    if (newVal === 660) {
      this.showOtherCPT = true
      this.$emit('update:cpt', newVal)
    } else {
      this.showOtherCPT = false
      const val = this.cptOptions?.filter(c => c.visitOptionID === newVal)[0]

      this.$emit('update:cpt', val)
    }
  }
  @Watch('otherCPT', { immediate: true, deep: true })
  onOtherCPT(newVal: number) {
    if (this.selectedCPT === 660) {
      this.$emit('update:cpt', this.otherCPT)
    }
  }

  public computeMinDate(): string {
    const today = new Date()
    const pastDate = new Date(today.setDate(today.getDate() - 90))
    return pastDate.toISOString().split('T')[0]
  }
  public onContext(ctx) {
    this.formatted = moment(ctx).format('MM-DD-YYYY')
    this.saveDraftToLocalStorageDebounced()
  }

  public onInput(ctx) {
    const a = moment(ctx).toDate()
    if (a.toString() != 'Invalid Date') this.form.serviceDate = a.toDateString()

    this.saveDraftToLocalStorageDebounced()
  }

  @Debounce({ millisecondsDelay: 3000 }) // debounce time in milliseconds (1 second)
  saveDraftToLocalStorageDebounced() {
    this.$emit('update:draft', {
      component: 'pnInfo', // or 'A2' depending on which
      data: this.form
    })
    // const obj = { pnInfo: { ...this.form } }
    // localStorage.setItem('pnInfoDraft', JSON.stringify(obj))
    // this.$emit('update:draft', this.form)
    // this.Draft.progressNote_Data = JSON.stringify(obj)
    // this.Draft.recordId = this.record
    // saveDraft(this.Draft)
  }
  public async created() {
    this.PNInformationResolve = await getDoctorInfo(this.record)
    this.dataAvailable = true
    this.selected = this.PNInformationResolve.patientInfo.sex.toString()
    this.form.age = this.PNInformationResolve?.patientInfo.age
    // console.log(this.data)
    // console.log(this.form)
    // console.log(this.data.serviceDate)
    // if (this.data.serviceDate)
    //   this.formatted = moment(this.data.serviceDate).format('MM-DD-YYYY')

    this.$emit('update:pninfo', this.PNInformationResolve)
  }
  @Watch('formatted', { deep: true, immediate: true })
  onLocalSelectedItemsChange(newVal: Record<string, string>) {
    this.$emit('update:servicedate', newVal)
  }
  @Watch('data', { deep: true, immediate: true })
  onDataChange(newVal: Record<string, string>) {
    if (newVal.serviceDate)
      this.formatted = moment(this.data.serviceDate).format('MM-DD-YYYY')
  }
}
